import { render, staticRenderFns } from "./vs-form-option.vue?vue&type=template&id=4e5a42ca&scoped=true"
import script from "./vs-form-option.vue?vue&type=script&lang=js"
export * from "./vs-form-option.vue?vue&type=script&lang=js"
import style0 from "./vs-form-option.vue?vue&type=style&index=0&id=4e5a42ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a42ca",
  null
  
)

export default component.exports